
const fields = [
  {
    type: "x-QuillEditor",
    label: "禾馨月子餐",
    model: "contents",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    required: true,
    textOn: '上架',
    textOff: '下架',
    valueOn: 'ON',
    valueOff: 'OFF',
  }
];

export default fields;
